import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation';

export default class ResubmitAssignmentMutation {
  constructor(props) {
    this.props = props;
  }

  submissionQuery = Relay.QL`
  fragment on ResubmitAssignmentPayload {
    card {
        id
        pid
        name
        rawData
        reAttemptAllowedCount
        minScaledScore
        hideAnswers
        isGradable
        performance(userId: $userId) {
          id
          scaledScore
          completionStatus
          timeSpent
          successStatus
          reAttemptCount
          actualSubmit
          progressMeasure
          rawScore
        }
      }
    }
  `;

  getQuery() {
    return Relay.QL`
        mutation resubmitAssignmentMutation($input_0: ResubmitAssignmentInput!, $userId: String) {
          resubmitAssignment(input: $input_0) {
            ${this.submissionQuery}
            clientMutationId
          }
        }
      `;
  }

  getVariables() {
    return {
      input: {
        rootOfferId: this.props.rootOfferId,
        assignmentCardId: this.props.assignmentCardId,
        userId: this.props.userId,
        timeStamp: new Date().toISOString()
      },
      userId: this.props.userId
    };
  }

  getConfigs() {
    return [
      {
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          course: this.props.courseRelayId,
          card: this.props.cardRelayId
        }
      }
    ];
  }

  commit(callbacks) {
    const query = this.getQuery();
    const variables = this.getVariables();
    const mutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);

    const config = this.getConfigs();
    mutation.commit(config);
  }
}
